import { create } from 'zustand'

interface SearchState {
  globalSearchTerm: string
  setGlobalSearchTerm: (term: string) => void
  clearSearch: () => void
}

export const useSearchStore = create<SearchState>((set) => ({
  globalSearchTerm: '',
  setGlobalSearchTerm: (term: string) => set({ globalSearchTerm: term }),
  clearSearch: () => set({ globalSearchTerm: '' }),
}))
